<template>
	<div class="wrap">
		<myHead></myHead>
		<div class="wrap_body">
			<div class="center">
				<div class="ucenter_main">
					<ucMenu num="4"></ucMenu>
					<div class="right_con">
						<div class="record_main">
							<el-card shadow="never" style="min-height:650px;margin-bottom: 20px;">
								<div class="data_wrap">
									<div class="top_box">
										<div class="filter">
											<div class="filter_item">
												统计日期：
												<el-date-picker
													style="border:none;width: 200px;font-size: 14px;padding: 0;"
													v-model="selectDay"
													type="daterange"
													range-separator="-"
													size="mini"
													@change="changeDate"
													value-format="yyyy-MM-dd"
													start-placeholder="开始日期"
													end-placeholder="结束日期">
												</el-date-picker>
											</div>
											<div class="filter_item">
												<span class="day_select" :class="{active:daySelectId == item.id}" v-for="(item,index) in daySelect" :key="index" @click="daySelectClick(item)">{{item.name}}</span>
											</div>
										</div>
									</div>
									<div class="top_box" style="border-bottom: 1px solid #EEEEEE;padding: 10px 0;">
										<div class="title">我的店群数据</div>
										<div class="filter">
<!--											<div class="tips_box">-->
<!--												<div class="desc">指标说明 <i class="iconfont icon-shuomingtishi"></i></div>-->
<!--												<div class="setting">设置 <i class="iconfont icon-shezhi2"></i></div>-->
<!--											</div>-->
										</div>
									</div>
									<div class="data_box">
										<div class="data_item" v-for="(item,index) in data_type_list" :key="index">
											<p class="name">{{item.name}}</p>
											<p class="val">{{item.val}}</p>
											<div class="rate">{{compare_str}} <span class="rate_val" :class="{active:item.rate_type == 1}"><i class="iconfont icon-Gc_64_public-DeclineOutlined" v-if="item.rate != 0"></i>{{item.rate}}%</span></div>
										</div>
									</div>
								</div>
							</el-card>
							<el-card shadow="never" style="min-height:650px;">
								<div class="data_wrap">
									<div class="top_box">
										<div class="ranking">
											<span class="rank_item" :class="{active:rank_type == 1}" @click="changeRankType(1)">店铺排行</span>
											<span class="rank_item" :class="{active:rank_type == 2}" @click="changeRankType(2)">款式排行</span>
<!--											<span class="rank_item" :class="{active:rank_type == 3}" @click="changeRankType(3)">用户排行</span>-->
										</div>
										<div class="filter">
											<div class="filter_item">
												店铺名
												<el-select v-model="selectShop" filterable placeholder="请选择或输入" @change="changeShop" style="height: 36px;">
													<el-option
														v-for="item in shopList"
														:key="item.id"
														:label="item.shop_name"
														:value="item.shop_id">
													</el-option>
												</el-select>
											</div>
											<div class="filter_item" style="padding-left: 0">
												<el-select v-model="selectKeys" placeholder="商品名称" @change="changeKeys" style="width: 120px">
													<el-option
														v-for="item in keysList"
														:key="item.value"
														:label="item.label"
														:value="item.value">
													</el-option>
												</el-select>
												<el-input v-model="keys_input" placeholder="请输入内容" @blur="changeKeysInput" style="border-left: 1px solid #ddd;width:180px"></el-input>
											</div>
										</div>
									</div>
								</div>
								<el-table highlight-current-row @selection-change="selection" row-key="id" :header-cell-style="{ background: '#eef1f6', color: '#454545', width: '80px','font-weight': 'bold' }" v-loading="loading" ref="multipleTable" class="eltable eltable_one" :data="list" style="width: 100%;margin-top: 20px;" v-if="rank_type == 1">
									<el-table-column align="center" property="scope" label="TOP" width="50">
										<template slot-scope="scope">
											<img :src="'https://admin.xiebb.com/assets/images/rank_'+scope.row.ranking+'.png'" v-if="scope.row.ranking < 4"/>
											<span v-if="scope.row.ranking >= 4">{{scope.row.ranking}}</span>
										</template>
									</el-table-column>
									<el-table-column align="left" property="shop_name" label="店铺名" width="150"></el-table-column>
									<el-table-column align="center" property="all_sales" label="全店营业额" width="100"></el-table-column>
									<el-table-column align="center" property="all_sales_orders" label="订单量" width="80"></el-table-column>
									<el-table-column align="center" property="all_purchase" label="采购量" width="80"></el-table-column>
									<el-table-column align="center" property="all_purchase_order_amount" label="采购应收" width="100"></el-table-column>
									<el-table-column align="center" property="all_purchase_amount" label="采购应付" width="100"></el-table-column>
									<el-table-column align="center" property="all_refund_shipping_num" label="退货发货量" width="100"></el-table-column>
									<el-table-column align="center" property="all_refund_shipping" label="退货运费" width="100"></el-table-column>
									<el-table-column align="center" property="all_refund_num" label="退货退款量" width="100"></el-table-column>
									<el-table-column align="center" property="all_refund_fee" label="退货退款额" width="100"></el-table-column>
									<el-table-column align="center" property="all_shipping_insurance" label="权益保险" width="100"></el-table-column>
									<el-table-column align="center" property="all_influencer_commission" label="达人佣金" width="100"></el-table-column>
									<el-table-column align="center" property="all_timeout_compensation" label="超时赔付" width="100"></el-table-column>
									<el-table-column align="center" property="all_violation_compensation" label="判罚扣款" width="100"></el-table-column>
									<el-table-column align="center" property="all_small_amount_payment" label="小额打款" width="100"></el-table-column>
									<el-table-column align="center" property="all_shop_service_fee" label="平台服务费" width="100"></el-table-column>
									<el-table-column align="center" property="all_qianchuan_fee" label="千川" width="80"></el-table-column>
									<el-table-column align="center" property="all_other_shop_fee" label="其他店铺扣款" width="110"></el-table-column>
									<el-table-column align="center" property="all_inventory_fee" label="铺货费" width="100"></el-table-column>
									<el-table-column align="center" property="all_purchase_fee" label="采购费" width="100"></el-table-column>
									<el-table-column align="center" property="all_shipping_num" label="发货量" width="100"></el-table-column>
									<el-table-column align="center" property="all_shipping_fee" label="代发费" width="100"></el-table-column>
									<el-table-column align="center" property="all_vip_fee" label="会员费" width="100"></el-table-column>
									<el-table-column align="center" property="all_total_profit" label="毛利润" width="100"></el-table-column>
								</el-table>
								<el-table highlight-current-row @selection-change="selection" row-key="id" :header-cell-style="{background: '#eef1f6', color: '#454545', width: '80px','font-weight': 'bold' }" v-loading="loading" ref="multipleTable" class="eltable eltable_two" :data="list" style="width: 100%;margin-top: 20px;" v-if="rank_type == 2">
									<el-table-column align="center" property="scope" label="TOP" width="50">
										<template slot-scope="scope">
											<img :src="'https://admin.xiebb.com/assets/images/rank_'+scope.row.ranking+'.png'" v-if="scope.row.ranking < 4"/>
											<span v-if="scope.row.ranking >= 4">{{scope.row.ranking}}</span>
										</template>
									</el-table-column>
									<el-table-column align="center" property="scope" label="商品图" width="80">
										<template slot-scope="scope">
											<img :src="scope.row.img" style="width: 40px;height: 40px;" />
										</template>
									</el-table-column>
									<el-table-column align="left" property="name" label="商品名" width="500">
										<template slot-scope="scope">
											<p style="cursor: pointer" @click="goDetail(scope.row.goods_id)" target="_blank">{{scope.row.name}}</p>
										</template>
									</el-table-column>
									<el-table-column align="center" property="all_sales" label="全部销售额" width="120"></el-table-column>
									<el-table-column align="center" property="all_purchase_order_amount" label="全部采购应收" width="120"></el-table-column>
									<el-table-column align="center" property="all_purchase_amount" label="全部采购应付" width="120"></el-table-column>
									<el-table-column align="center" property="all_sales_orders" label="全部单数" width="120"></el-table-column>
									<el-table-column align="center" property="all_total_profit" label="全部毛利" width="120"></el-table-column>
									<el-table-column align="center" property="all_profit_rate" label="全部毛利率" width="120">
										<template slot-scope="scope">
											{{scope.row.all_profit_rate}}%
										</template>
									</el-table-column>
									<el-table-column align="center" property="all_refund_num" label="全部退单数" width="120"></el-table-column>
									<el-table-column align="center" property="all_refund_rate" label="全部退单率" width="120">
										<template slot-scope="scope">
											{{scope.row.all_refund_rate}}%
										</template>
									</el-table-column>
								</el-table>
								<el-table highlight-current-row @selection-change="selection" row-key="id" :header-cell-style="{ background: '#eef1f6', color: '#606266', width: '50px' }" v-loading="loading" ref="multipleTable" class="eltable eltable_three" :data="list" style="width: 100%;margin-top: 20px;" v-if="rank_type == 3">
									<el-table-column align="center" property="scope" label="TOP" width="50">
										<template slot-scope="scope">
											<img :src="'/assets/images/rank_'+scope.row.ranking+'.png'" v-if="scope.row.ranking < 4"/>
											<span v-if="scope.row.ranking >= 4">{{scope.row.ranking}}</span>
										</template>
									</el-table-column>
									<el-table-column align="center" property="business_mobile" label="手机号" width=""></el-table-column>
									<el-table-column align="center" property="all_sales" label="全店营业额" width="100"></el-table-column>
									<el-table-column align="center" property="all_sales_orders" label="订单量" width="60"></el-table-column>
									<el-table-column align="center" property="all_purchase" label="采购量" width="60"></el-table-column>
									<el-table-column align="center" property="all_purchase_order_amount" label="采购应收" width="100"></el-table-column>
									<el-table-column align="center" property="all_purchase_amount" label="采购应付" width="100"></el-table-column>
									<el-table-column align="center" property="all_refund_num" label="退货退款量" width="60"></el-table-column>
									<el-table-column align="center" property="all_refund_fee" label="退货退款额" width="80"></el-table-column>
									<el-table-column align="center" property="all_shipping_insurance" label="权益保险" width="60"></el-table-column>
									<el-table-column align="center" property="all_influencer_commission" label="达人佣金" width="60"></el-table-column>
									<el-table-column align="center" property="all_timeout_compensation" label="超时赔付" width="60"></el-table-column>
									<el-table-column align="center" property="all_violation_compensation" label="判罚扣款" width="60"></el-table-column>
									<el-table-column align="center" property="all_small_amount_payment" label="小额打款" width="60"></el-table-column>
									<el-table-column align="center" property="all_shop_service_fee" label="平台服务费" width="80"></el-table-column>
									<el-table-column align="center" property="all_qianchuan_fee" label="千川" width="60"></el-table-column>
									<el-table-column align="center" property="all_other_shop_fee" label="其他店铺扣款" width="80"></el-table-column>
									<el-table-column align="center" property="all_inventory_fee" label="铺货费" width="80"></el-table-column>
									<el-table-column align="center" property="all_purchase_fee" label="采购费" width="80"></el-table-column>
									<el-table-column align="center" property="all_shipping_fee" label="代发费" width="80"></el-table-column>
									<el-table-column align="center" property="all_vip_fee" label="会员费" width="60"></el-table-column>
									<el-table-column align="center" property="all_total_profit" label="毛利润" width="100"></el-table-column>
								</el-table>
<!--								<Page :total.sync="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit" @pagination="getRanking" style="text-align: right"/>-->
								<div class="turn_page">
									<Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit" @pagination="getRanking" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10,50,100]"/>
								</div>
							</el-card>
						</div>
					</div>
				</div>
			</div>
		</div>
		<myFoot></myFoot>
	</div>
</template>
<script>
import ucMenu from "@/components/ucenterMenu/ucmenu.vue";
import myHead from "@/components/myHead/myhead.vue";
import myFoot from "@/components/myFoot/myfoot.vue";
import {mapActions, mapState} from "vuex";
import Pagination from "@/components/pagination/pagination.vue";

export default {
	name: "ucenterStatistic",
	data() {
		return {
			rangeTime: "",
			startTime: "",
			endTime: "",
			tableData: [],
			statisticData: {},
			list: [],
			searchData: {},
			compare_str: '',
			rank_type: 1,
			daySelect: [
				{id: 1, name: '今天', day: '0'},
				{id: 2, name: '昨天', day: '1'},
				{id: 3, name: '近7天', day: '7'},
				{id: 4, name: '近30天', day: '30'},
				{id: 5, name: '近60天', day: '60'},
				{id: 6, name: '近90天', day: '90'},
				{id: 7, name: '本月', day: 'this_month'},
				{id: 8, name: '上月', day: 'prev_month'},
			],
			daySelectId: 1,
			selectDay: "",
			page_data: {
				page: 1,
				limit: 10,
				total: 0
			},
			data_type_list: [],
			express_data_type_list: [
				{id: 1, name: '圆通', val: '--', rate: 0 + '%', rate_type: 1},
				{id: 2, name: '申通', val: '--', rate: 0 + '%', rate_type: 1},
				{id: 3, name: '中通', val: '--', rate: 0 + '%', rate_type: 1},
				{id: 4, name: '韵达', val: '--', rate: 0 + '%', rate_type: 1},
				{id: 5, name: '极兔', val: '--', rate: 0 + '%', rate_type: 1},
				{id: 6, name: '京东', val: '--', rate: 0 + '%', rate_type: 1},
				{id: 7, name: '邮政', val: '--', rate: 0 + '%', rate_type: 1},
				{id: 8, name: '顺丰', val: '--', rate: 0 + '%', rate_type: 1},
				{id: 9, name: '其他', val: '--', rate: 0 + '%', rate_type: 1},
				{id: 10, name: '合计', val: '--', rate: 0 + '%', rate_type: 1}

			],
			express_output_type_list: [
				{id: 1, name: '圆通', val: '--', rate: 0 + '%', rate_type: 1},
				{id: 2, name: '邮政', val: '--', rate: 0 + '%', rate_type: 1},
				{id: 3, name: '合计', val: '--', rate: 0 + '%', rate_type: 1}
			],
			shopList: [],
			selectShop: '',
			keysList: [{
				value: 'product_name',
				label: '商品名称',
			}],
			selectKeys: 'product_name',
			keys_input: ''
		}
	},
	components: {
		Pagination,
		myHead, myFoot, ucMenu
	},
	computed: {
		...mapState({
			userinfo: (state) => state.login.userinfo,
		}),
	},
	created() {
		this.index()
		this.getRanking()
		this.refreshTimer = setInterval(() => {
			this.index()
		}, 5000);
	},
	beforeDestroy() {
		clearInterval(this.refreshTimer)
	},
	methods: {
		...mapActions({
			getStatisticData: "ucenter/opGetStatisticData",
			getStatisticRanking: "ucenter/opGetStatisticRanking",
			getStatisticExpressData: "ucenter/opGetStatisticExpressData",
			checkBind: "ucenter/uShareBillCheckBind",
		}),
		changeRankType(type) {
			this.rank_type = type
			this.page_data.page = 1
			this.getRanking()
		},
		changeShop() {
			this.searchData.shop_id = this.selectShop
			this.getRanking()
		},
		changeKeys() {
			this.searchData.keys = this.selectKeys
		},
		changeKeysInput(){
			this.getRanking()
		},
		goDetail(goods_id){
			this.$router.push({
				path: 'uc_statistic_product_detail',
				query: {
					goods_id: goods_id,
					menuId: 133
				}
			})
		},
		index() {
			let params = {
				page: this.page,
				page_size: this.page_size,
			}
			params = Object.assign(params, this.searchData)
			this.getStatisticData({
				data: params,
				success: (res) => {
					if (res.code === 200) {
						console.log('get share bill data', res)
						this.data_type_list = res.data.list
						this.express_data_type_list = res.data.expressData
						this.express_output_type_list = res.data.expressOutData
						this.compare_str = res.data.compare_str
					} else {
						this.$message({message: res.msg, type: 'error',});
					}
				}
			})
		},
		getRanking() {
			let params = {limit: this.page_data.limit, page: this.page_data.page, type: this.rank_type, keys: this.selectKeys, keys_input: this.keys_input}
			Object.assign(params, this.searchData)
			this.loading = true
			this.getStatisticRanking({
				data: params,
				success: (res) => {
					if (res.code === 200) {
						this.list = res.data.list.data
						this.page_data.total = res.data.list.total
						this.shopList = res.data.shop_list
						this.loading = false
					} else {
						this.$message({message: res.msg, type: 'error',});
					}
				}
			})
		},
		changeDate(e) {
			console.log(this.selectDay)
			if (this.selectDay) {
				this.searchData.start_time = this.selectDay[0];
				this.searchData.end_time = this.selectDay[1]
				this.daySelectId = ''
				this.searchData.select_day = ''
			} else {
				this.searchData.start_time = ''
				this.searchData.end_time = ''
				this.daySelectId = 1
				this.searchData.select_day = this.daySelect[0].day
			}

			this.index()
			this.getRanking()
		},
		daySelectClick(e) {
			console.log(e)
			this.selectDay = ''
			this.searchData.start_time = ''
			this.searchData.end_time = ''
			this.daySelectId = e.id
			this.searchData.select_day = e.day
			this.index()
			this.getRanking()
		},
		selection(selection) {
			this.ids = selection.map(item => item.id)
			this.single = selection.length == 0
		},
		currentChange(val) {
			this.page = val
			this.getShareBill()
			console.log(val)
		}
	}
}

</script>

<style scoped>
.wrap .wrap_body{display: flex;flex-direction: column;}
.center{display: flex;flex: 1;}
.ucenter_main{padding: 30px 0 40px;display: flex;justify-content: space-between;flex: 1;}
.right_con{width: 980px;}
.el-card__body{padding:12px 20px;}

.data_wrap .top_box{display: flex;justify-content: space-between;align-items: center;}
.data_wrap .top_box .title{font-weight: bold;font-size: 14px;color: #000000;}
.data_wrap .top_box .filter{display: flex;font-weight: 400;font-size: 14px;color: #737E97;min-height: 32px;}
.data_wrap .top_box .filter .filter_item{border-radius: 6px;border: 1px solid #DCDFE6;display: flex;align-items: center;padding-left:15px;margin-right: 19px;}
.data_wrap .top_box .filter .filter_item .day_select{border-right:1px solid #E1EBFE;height:14px;line-height: 14px;padding-right: 10px;margin-right: 10px;cursor: pointer;}
.data_wrap .top_box .filter .filter_item .day_select.active{color: #236CFF;}
.data_wrap .top_box .filter .filter_item .day_select:last-child{border-right:none;margin-right: 0px;}
.data_wrap .top_box .filter .filter_item:last-child{margin-right: 0px;}
.data_wrap .top_box .filter .tips_box{display: flex;align-items: center;}
.data_wrap .top_box .filter .tips_box .desc{display: flex;align-items: center;border-right:2px solid #E1EBFE;line-height:15px;padding-right: 10px;margin-right: 10px;}
.data_wrap .top_box .filter .tips_box .iconfont{font-size:12px;color:#737E97;margin-left: 3px;}

.data_wrap .data_box{ display: flex;justify-content: flex-start;align-items: center;flex-wrap: wrap;margin-top: 20px;}
.data_wrap .data_box .data_item{width: 145px;height: 100px;background: #FFFFFF;border-radius: 6px;box-shadow: 0 0 15px 2px rgba(236, 243, 255, 0);margin-right:10px;margin-bottom:20px;padding: 12px;transition: all 0.3s ease;}
.data_wrap .data_box .data_item:hover {box-shadow: 0 0 15px 2px rgba(236, 243, 255, 0.8);transform: translateY(-5px);cursor: pointer;}
.data_wrap .data_box .data_item.active{box-shadow: 0 0 15px 2px rgba(236, 243, 255, 1);}
.data_wrap .data_box .data_item .name{font-size: 12px;color: #454545;}
.data_wrap .data_box .data_item .val{font-weight: normal;font-size: 22px;color: #000000;}
.data_wrap .data_box .data_item .rate{font-weight: 400;font-size: 14px;color: #454545;white-space: nowrap;}
.data_wrap .data_box .data_item .rate .rate_val{color: #2CD9C5;}
.data_wrap .data_box .data_item .rate .rate_val .iconfont{margin:0 6px;display: inline-block;}
.data_wrap .data_box .data_item .rate .rate_val.active{color: #F52929;}
.data_wrap .data_box .data_item .rate .rate_val.active .iconfont { transform: scaleY(-1);}

.data_wrap .top_box .ranking{height: 36px;border-radius: 6px;border: 1px solid #DCDFE6;display: flex;align-items: center;padding: 0 2px;}
.data_wrap .top_box .ranking .rank_item{width: 80px;height: 30px;background: #FFFFFF;border-radius: 6px;display: flex;align-items: center;justify-content: center;color: #737E97;font-size:14px;cursor: pointer;}
.data_wrap .top_box .ranking .rank_item.active{background: #F0413E;color: #fff;}

:deep(.filter_item .el-range-editor--mini .el-range-separator) {
	line-height: 36px !important;
}
:deep(.filter_item .el-input__inner) {
	border: none !important; /* 或者使用其他自定义边框样式 */
	height: 36px !important;
}
:deep(.el-table th.el-table__cell>.cell){
	padding: 0 !important;
}
.el-table th{
	white-space: nowrap;
}
:deep(.eltable_one .el-table__cell:nth-child(2)>.cell){
	padding-left: 10px !important;
}
:deep(.eltable_two .el-table__cell:nth-child(3)>.cell){
	padding-left: 10px !important;
}
:deep(.el-date-editor){
	margin-top: 0 !important;
}
.el-table .cell{white-space: nowrap;text-overflow: initial;}
.turn_page {
	display: flex;
	justify-content: flex-end;
	margin-top: 10px;
}
</style>